import {
  AfterViewInit,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { Chart, registerables } from 'chart.js';
import { Admis } from 'src/app/model/Admis';
import { BreadcrumbItem } from 'src/app/modules/shared/components/breadcrumb/breadcrumb.component';
import { AppelsService } from '../../service/appels.service';
import { UtilisateursService } from 'src/app/modules/utilisateurs/services/utilisateurs.service';
import { SpinnerServiceService } from 'src/app/modules/shared/serviceSpinner/spinner-service.service';
import { ActivatedRoute } from '@angular/router';

Chart.register(...registerables);
export interface dataMStat {
  name: string;
  Homme: number;
  Femme: number;
}

export interface AdmisByGender {
  family: String;
  Data: { homme: number; femme: number };
}

@Component({
  selector: 'app-horsigui-admi',
  templateUrl: './horsigui-admi.component.html',
  styleUrls: ['./horsigui-admi.component.css'],
})
export class HorsiguiAdmiComponent implements OnInit {
  @ViewChild('notificationButton') toggleButton!: ElementRef;

  dataStat: dataMStat[] = [];
  AllAdmis: Admis[] = [];
  AllAdmisGender: any[] = [];
  totalHomme: number = 0;
  totalFemme: number = 0;
  showModal: boolean = false;
  showMailSent: boolean = false;
  showDetails: boolean = false;
  hide: boolean = false;
  showSpinner = false;
  displayedColumns: string[] = [
    'iuf',
    'prenom',
    'nom',
    'age',
    'mail',
    'confirmation',
    'actions',
  ];
  dataSource = new MatTableDataSource<Admis>();

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  isFromList: string[] = [];
  selectedIsFrom: string = '';

  // Variables for Graph
  chart!: any;
  chart2!: any;
  hommes: number[] = [];
  femmes: number[] = [];
  CountMaleAdmitted: number[] = [];
  CountFmaleAdmitted: number[] = [];
  NoIAPThomme: number = 0;
  NoIAPTfemme: number = 0;
  NoC2Ihomme: number = 0;
  NoC2Ifemme: number = 0;
  NoMDhomme: number = 0;
  NoMDfemme: number = 0;
  NoCDhomme: number = 0;
  NoCDfemme: number = 0;
  NoIIhomme: number = 0;
  NoIIfemme: number = 0;
  NoTLhomme: number = 0;
  NoTLfemme: number = 0;
  NoInthomme: number = 0;
  NoIntfemme: number = 0;
  NoENhomme: number = 0;
  NoENfemme: number = 0;
  NototalHomme: number = 0;
  NototalFemme: number = 0;
  totalGlobalH: number = 0;
  totalGlobalF: number = 0;
  totalGlobalHommeFemmeAdmis: number = 0;
  totalGlobalHommeFemmeNoAdmis: number = 0;

  cohorte: any = null;

  @ViewChild('canvasConfirmation') canvas!: ElementRef<HTMLCanvasElement>;

  ligneDetails!: Admis;

  confirmed!: any;
  notConfirmed!: any;

  breadcrumbItems!: BreadcrumbItem[];

  constructor(
    private appelsService: AppelsService,
    private utilisateurService: UtilisateursService,
    private spinnerService: SpinnerServiceService,
    private route: ActivatedRoute,
  ) {
    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });
  }

  ngOnInit() {
    this.route.params.subscribe((data: any) => {
      this.cohorte = data['cohortId'];
      this.getlistAdmis(this.cohorte);
      this.getListAdmisByGender(this.cohorte);
      this.loadIsFromValues(this.cohorte);
    });
    this.totalGlobalH = this.totalHomme + this.NototalHomme;
    this.totalGlobalF = this.totalFemme + this.NototalFemme;

    this.breadcrumbItems = [
      { label: 'HORS SIGUI' },
      {
        label: `SESSION ${this.cohorte}`,
        url: `/dashboard/appels/candidaturesHS/${this.cohorte}`,
      },
      { label: 'ADMIS', url: `/dashboard/appels/admisHS/${this.cohorte}` },
    ];
  }

  getlistAdmis(cohorte: string): void {
    this.spinnerService.showSpinner();
    this.utilisateurService.getAdmisHorsSiguiStat(cohorte).subscribe({
      next: (list: Admis[]) => {
        this.spinnerService.hideSpinner();
        this.dataSource.data = list;
        this.dataSource.paginator = this.paginator;
      },
      error: (err) => {
        this.spinnerService.hideSpinner();
        // console.log('erreur liste admis ', err);
        alert('Erreur de Recuperation des Données');
      },
    });
  }

  Verifydata(data: any, oldData: any) {
    if (data != null) {
      return data + oldData;
    }
    return oldData;
  }

  getListAdmisByGender(cohorte: string): void {
    this.utilisateurService
      .getCertificatedHorsSiguiStat(cohorte)
      .subscribe((data: any) => {
        const key = Object.keys(data);

        for (const k of key) {
          // console.log("cles ", data[k]);

          if (data[k] != null) {
            const dStat: dataMStat = {
              name: k,
              Homme: data[k]?.Homme != null ? data[k]?.Homme : 0,
              Femme: data[k]?.Féminin != null ? data[k]?.Féminin : 0,
            };
            this.dataStat.push(dStat);
          }
        }

        for (const l of this.dataStat) {
          this.totalFemme += l.Femme;
          this.totalHomme += l.Homme;
        }

        // console.log('Stat Homme', this.totalHomme);
        // console.log(this.IAPThomme, this.CDhomme);
      });
  }

  exportPDF(): void {
    this.appelsService.exportToPDF().subscribe({
      next: (response: Blob) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url); // Ovr nvll fenêtre
      },
      error: (error) => {
        console.error('Error exporting PDF:', error);
      },
    });
  }

  loadIsFromValues(cohorte: string): void {
    this.appelsService.getDistinctIsFromByCohorte(cohorte).subscribe({
      next: (values: string[]) => {
        this.isFromList = values;
      },
      error: (err) => {
        console.error('Erreur lors du chargement des valeurs isFrom', err);
      },
    });
  }

  exportAdmisPDFHorsSigui(): void {
    this.appelsService.exportAdmisPDFHorsSigui().subscribe({
      next: (response: Blob) => {
        const blob = new Blob([response], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url);
      },
      error: (error) => {
        console.error('Error exporting PDF:', error);
      },
    });
  }

  exportHorsSiguiExcelAdmis() {
    this.appelsService
      .exportHorsSiguiExcelAdmis(this.cohorte, this.selectedIsFrom)
      .subscribe((data) => {
        const blob = new Blob([data], {
          type: 'application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const donnees = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = donnees;

        const fileName = this.selectedIsFrom
          ? `admis_${this.selectedIsFrom}_${this.cohorte}.xlsx`
          : `admis_${this.cohorte}.xlsx`;
        link.download = fileName;

        link.dispatchEvent(
          new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window,
          }),
        );

        setTimeout(function () {
          window.URL.revokeObjectURL(donnees);
          link.remove();
        }, 100);
      });
  }

  changeHide() {
    if (this.toggleButton) {
      this.toggleButton.nativeElement.click();
    }
  }

  toggleModal() {
    this.showModal = !this.showModal;
  }

  toggleModalDetails(row: Admis) {
    this.ligneDetails = row;
    this.showDetails = true;
  }
  closeModalDetails() {
    this.showDetails = false;
  }

  notifierMail() {
    this.showModal = !this.showModal;

    this.spinnerService.showSpinner();

    this.appelsService
      .notifierAdmission()
      .pipe()
      .subscribe({
        next: (response) => {
          if (response.status == 200) {
            this.spinnerService.hideSpinner();

            this.showMailSent = true;
          }
        },
        error: (err) => {
          alert("Erreur d'envoi des mails ! Merci reessayer plus tard ");
          this.spinnerService.hideSpinner();
        },
      });
  }

  closeMailSentDialog() {
    this.showMailSent = !this.showMailSent;
  }

  /*applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }*/

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.applyFilters(filterValue, this.selectedIsFrom);
  }

  onIsFromChange(value: string) {
    this.selectedIsFrom = value;
    const searchValue =
      (document.querySelector('input[matInput]') as HTMLInputElement)?.value ||
      '';
    this.applyFilters(searchValue, value);
  }

  applyFilters(searchValue: string, isFromValue: string) {
    this.dataSource.filterPredicate = (data: Admis, filter: string) => {
      const [search, isFrom] = filter.split('|');

      const matchesSearch =
        !search ||
        data.iuf?.toLowerCase().includes(search) ||
        data.firstName?.toLowerCase().includes(search) ||
        data.lastName?.toLowerCase().includes(search) ||
        data.email?.toLowerCase().includes(search);

      const normalizedDataIsFrom =
        !data.isFrom || data.isFrom.trim() === '' ? 'FODE' : data.isFrom;
      const matchesIsFrom = !isFrom || normalizedDataIsFrom === isFrom;

      return matchesSearch && matchesIsFrom;
    };

    this.dataSource.filter = `${searchValue
      .trim()
      .toLowerCase()}|${isFromValue}`;

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Nombre des hommes, femme admis

  getConfirmedFromAdmitted() {
    this.spinnerService.showSpinner();
    this.utilisateurService
      .getConfirmed()
      .pipe()
      .subscribe({
        next: (stats) => {
          this.confirmed = stats?.['Confirmé'];
          this.notConfirmed = stats?.['Pas encore confirmé'];

          this.setTotalConfirmed_NoConfirmedChart('Le nombre de confirmation');
        },
        error: (err) => {
          alert('Erreur de Recuperation des Données');
        },
      });
  }

  // mettre à jr la somme totale
  updateTotalGlobal(): void {
    // Calcul de la somme totale
    this.totalGlobalH = this.totalHomme + this.totalFemme;
    this.totalGlobalF = this.NototalHomme + this.NototalFemme;
    this.totalGlobalHommeFemmeAdmis = this.totalHomme + this.totalFemme;
    this.totalGlobalHommeFemmeNoAdmis = this.NototalHomme + this.NototalFemme;
  }

  setTotalConfirmed_NoConfirmedChart(title: string) {
    const ctx = this.canvas.nativeElement.getContext('2d');
    if (ctx) {
      if (this.chart) {
        this.chart.destroy(); // Nettoyer le graphique précédent s'il existe
      }

      this.chart = new Chart(ctx, {
        type: 'pie',
        data: {
          labels: ['Confirmé', 'Pas encore confirmé'],
          datasets: [
            {
              label: 'My First Dataset',
              data: [this.confirmed, this.notConfirmed],
              backgroundColor: ['rgb(14, 159, 110)', 'rgb(240, 82, 82)'],
              hoverOffset: 4,
            },
          ],
        },
        options: {
          plugins: {
            title: {
              display: true,
              text: title,
            },
          },
          responsive: true,
          interaction: {
            intersect: false,
          },
          scales: {
            x: { stacked: true },
            y: { stacked: true },
          },
        },
      });

      this.spinnerService.hideSpinner();
    }
  }
}
